<template>
  <div class="ticket-encerramento ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="4">
          <label for="status-multiselect">Status </label>
          <multiselect
            id="status-multiselect"
            v-model="value_status"
            :options="statussEncerramento"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o(s) status"
            label="status"
            track-by="id_status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} status selecionado(s)
              </span>
            </template>
          </multiselect>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="loadsacsolicitacoesEncerramento"
            block
          >
            Carregar
          </b-button>
        </b-col>

        <b-col cols="5">
          <label for="search-input">Pesquisa no grid</label>
          <b-form-input
            id="search-input"
            v-model="search"
            placeholder="Registro, Tipo de solicitação ou palavras-chave"
          />
        </b-col>

        <b-col cols="2">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="handleNovo"
            v-b-modal.modal-multi-tratativas
            block
          >
            Novo
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-row class="mt-3">
      <b-col cols="3" v-for="card in statusCards" :key="card.label">
        <b-card
          :style="{ width: '100%' }"
          border-variant="primary"
          :header="card.label"
          :header-bg-variant="card.variant"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>{{ card.count }}</h2>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Carregando..."></b-spinner>
    </div>

    <b-table
      id="tabela-solicitacoes"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="campoTratativas"
    >
      <template #cell(actions)="data">
        <b-button
          @click="
            loadStatus(),
              loadCarregaSac(data.item),
              loadCarregaSacT(),
              loadsacsolicitacoesEncerramentoTratativas(),
              loadSacSolicitacoesTratativas(),
              loadResposta()
          "
          title="Editar solicitação."
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-tratativas
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <b-modal
      id="modal-SolicitanteFotos"
      hide-footer
      size="lg"
      :title="`Fotos da solicitação: ${sacsolicitacaoEncerramento.id_solicitacao}`"
      no-close-on-backdrop
    >
      <div class="d-flex justify-content-center" style="height: 80vh">
        <b-carousel
          id="carouselFoto"
          class="carouselFoto"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          style="text-shadow: 1px 1px 2px #333"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
            v-for="item in solicitacao"
            :key="item.id"
            :img-src="item.foto_thumbnail"
            :alt="`Foto da solicitação ${item.id}`"
          />
        </b-carousel>
      </div>
    </b-modal>

    <!-- IMPORTANTE: modais separados devem ficar no final -->

    <b-modal
      id="modal-multi-tratativas"
      cancel-title="Fechar"
      ok-title="Gravar"
      @ok.prevent="postSac(), postNotificacao()"
      size="xl"
      :title="`Solicitação Nº.: ${
        sacsolicitacaoEncerramento.id_solicitacao != null
          ? sacsolicitacaoEncerramento.id_solicitacao
          : '-'
      }`"
      no-close-on-esc
      no-close-on-backdrop
    >
      <!-- ,postSacTratativa(),putSacTratativa(),postNotificacao() -->
      <div>
        <b-row
          v-if="
            sacsolicitacaoEncerramento.id_solicitacao !== '' &&
            sacsolicitacaoEncerramento.id_solicitacao !== null
          "
        >
          <input
            id="id-sac"
            type="hidden"
            v-model="sacsolicitacaoEncerramento.id_solicitacao"
          />

          <b-col cols="1" class="mt-2 pr-4">
            <b-form-group label="" label-for="tabela-foto">
              <b-img
                height="120"
                width="78"
                class="mb-5"
                v-model="sacsolicitacaoEncerramento.foto_url"
                v-bind="mainProps"
                rounded
                alt="Foto"
                :src="sacsolicitacaoEncerramento.foto_url"
              >
              </b-img>
            </b-form-group>
          </b-col>

          <b-col cols="2" class="mt-5">
            <label for="input-live">Registro</label>
            <b-form-input
              id="resolicitante"
              v-model="sacsolicitacaoEncerramento.re_solicitante"
              readonly
              placeholder=""
              class="mb-3"
            ></b-form-input>
          </b-col>

          <b-col cols="3" class="mt-5">
            <label for="input-live">Nome</label>
            <b-form-input
              id="resolicitante"
              v-model="sacsolicitacaoEncerramento.nome"
              readonly
              placeholder=""
              class="mb-3"
            ></b-form-input>
          </b-col>

          <b-col cols="3" class="mt-5">
            <label for="input-live">Função </label>
            <b-form-input
              id="resolicitante"
              v-model="sacsolicitacaoEncerramento.funcao_solicitante"
              readonly
              placeholder=""
            ></b-form-input>
          </b-col>

          <b-col sm="2" class="mt-5">
            <label for="input-resolicitante">Status</label>
            <div>
              <b-form-select
                id="resolicitante"
                v-model="sacsolicitacaoEncerramento.id_status"
                :options="statussEncerramento"
                class="mb-3"
                text-field="status"
              >
              </b-form-select>
            </div>
          </b-col>

          <b-col cols="1" class="mt-5">
            <label for="input-live"> </label>
            <b-button
              block
              variant="warning"
              class="mr-2 mt-1"
              @click="loadSolicitacaoFoto()"
              v-b-modal.modal-SolicitanteFotos
              >Fotos</b-button
            >
          </b-col>
        </b-row>

        <b-row
          v-if="
            sacsolicitacaoEncerramento.id_solicitacao == '' ||
            sacsolicitacaoEncerramento.id_solicitacao == null
          "
        >
          <b-col sm="3">
            <label for="textarea-small">Justificativa</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea
              id="id-pecas"
              v-model="sacsolicitacaoEncerramento.justificativa"
              readonly
              size="sm"
              class="mb-3"
              placeholder="Pergunta do colaborador"
            ></b-form-textarea>
          </b-col>
        </b-row>

        <b-row
          v-if="
            sacsolicitacaoEncerramento.id_solicitacao == '' ||
            sacsolicitacaoEncerramento.id_solicitacao == null
          "
        >
          <b-col cols="4" sm="4" class="mt-1">
            <label for="input-parecer">Departamento</label>
            <div>
              <b-form-select
                id="infoFormato"
                v-model="sacsolicitacaoEncerramento.departamento_id"
                :options="departamentos"
                class="mb-3"
                text-field="area"
                @change="loadAssunto()"
              >
              </b-form-select>
            </div>
          </b-col>

          <b-col cols="4" sm="4" class="mt-1">
            <label for="input-parecer">Assunto</label>
            <div>
              <b-form-select
                id="infoFormato"
                v-model="sacsolicitacaoEncerramento.assunto_id"
                :options="assuntos"
                class="mb-3"
                text-field="modulo"
                @change="loadMotivo()"
              >
              </b-form-select>
            </div>
          </b-col>

          <b-col cols="4" sm="4" class="mt-1">
            <label for="input-parecer">Motivo</label>
            <div>
              <b-form-select
                id="infoFormato"
                v-model="sacsolicitacaoEncerramento.motivo_id"
                :options="motivos"
                class="mb-3"
                text-field="motivo"
              >
              </b-form-select>
            </div>
          </b-col>
        </b-row>

        <!-- Exibir o bloco de datas e o valor de 'atestado' SOMENTE se um motivo estiver selecionado E 'atestado' for true -->
        <div v-if="sacsolicitacaoEncerramento.dt_atestado_ini">
          <b-row class="mb-4">
            <b-col cols="4">
              <div>
                <label for="datepicker-placeholder">Data atestado inicio</label>

                <b-form-datepicker
                  id="dt_sol_inicial"
                  required
                  v-model="sacsolicitacaoEncerramento.dt_atestado_ini"
                  placeholder="Data inicial "
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="4">
              <div>
                <label for="datepicker-placeholder"
                  >Data atestado término</label
                >
                <b-form-datepicker
                  id="dt_sol_final"
                  required
                  v-model="sacsolicitacaoEncerramento.dt_atestado_fim"
                  placeholder="Data do final"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>
          </b-row>
        </div>
        <!--tbl de dados -->
        <b-table
          id="resolicitante"
          v-if="
            sacsolicitacaoEncerramento.id_solicitacao !== '' ||
            sacsolicitacaoEncerramento.id_solicitacao !== null
          "
          small
          hover
          striped
          sticky-header="330px"
          :items="sacsolicitacoesEncerramentotratativa"
          :fields="tratativas"
        >
        </b-table>

        <b-row>
          <b-col cols="12" class="mt-5">
            <label for="input-resolicitante">Resposta padrão</label>
            <div>
              <b-form-select
                id="resolicitante"
                v-model="sacResposta.id"
                :options="sacResposta"
                class="mb-3"
                text-field="resposta"
                value-field="id"
                @change="atualizarParecer"
              />
            </div>
          </b-col>

          <b-col sm="12">
            <label for="textarea-small">Parecer da solicitação:</label>
          </b-col>

          <b-col cols="10">
            <b-form-textarea
              id="id-obs"
              v-model="sacsolicitacaoEncerramento.parecer"
              size="sm"
              placeholder="Digite o parecer"
            ></b-form-textarea>
          </b-col>

          <b-col v-if="this.user.gestor" cols="2" class="mb-1">
            <b-form-checkbox
              id="aprovado"
              v-model="sacsolicitacaoEncerramento.aprovado"
              name="checkbox-1"
              value="true"
              unchecked-value="false"
              checked="true"
              @change="handleCheckboxChange"
            >
              Aprovado compra
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="10"
            class="mt-2"
            v-if="sacsolicitacaoEncerramento.id_status == 3"
          >
            <label for="textarea-small">Avaliação do atendimento:</label>
            <b-form-rating
              :value="sacsolicitacaoEncerramento.avaliacao"
              readonly
              variant="warning"
            ></b-form-rating>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mb-3 mt-3 ml-5">
            <div>
              <b-img
                v-if="sacsolicitacaoEncerramento.file === 'true'"
                :src="sacsolicitacaoEncerramento.file"
                width="600"
                height="600"
              ></b-img>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "sacsolicitacaoEncerramento",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      // Começa com todos os itens
      let valores = this.sacsolicitacoesEncerramento;

      // Aplica filtro de texto, se houver
      if (this.search && this.search.trim() !== "") {
        const searchLower = this.search.toLowerCase();
        valores = valores.filter((item) => {
          return (
            item.re_solicitante
              ?.toString()
              .toLowerCase()
              .includes(searchLower) ||
            item.parecer?.toLowerCase().includes(searchLower) ||
            item.justificativa?.toLowerCase().includes(searchLower)
          );
        });
      }

      // Aplica filtro por múltiplos status, se houver
      if (this.value_status.length > 0) {
        const selectedStatusIds = this.value_status.map((s) => s.id_status);
        valores = valores.filter((item) =>
          selectedStatusIds.includes(item.id_status)
        );
      }

      return valores;
    },
  },

  data: function () {
    return {
      sacsolicitacaoEncerramento: {},
      sacResposta: [],
      sacsolicitacoesEncerramento: [],
      pedidoferias: [],
      sacT: {},
      sacsolicitacoesEncerramentotratativa: [],
      search: "",
      departamentos: [],
      assuntos: [],
      motivos: [],
      idRetornoSolicitacao: null,
      solicitacao: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      empresa: {},
      empresas: [],
      value_empresa: [],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [],

      status: {},
      statussEncerramento: [],

      permissoes: [],
      permissao: {},

      value_id_area: "",

      campoTratativas: [
        { key: "id_solicitacao", label: "Nº Solicitação", sortable: true },
        { key: "id_filial", label: "Filial", sortable: true },
        { key: "re_solicitante", label: "Solicitante", sortable: true },
        { key: "funcao_solicitante", label: "Função", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data_Abertura_Solicitação",
          sortable: true,
          formatter: (value, key, sacsolicitacoesEncerramento) => {
            return moment(sacsolicitacoesEncerramento.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_finalizada",
          label: "Data_Encerramento",
          sortable: true,
          formatter: (value, key, sacsolicitacoesEncerramento) => {
            return moment(sacsolicitacoesEncerramento.dt_finalizada)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "tempo", label: "Duração", sortable: false },
        { key: "statussEncerramento", label: "Status", sortable: true },
        { key: "area", label: "Departamento", sortable: true },
        { key: "modulo", label: "Tipo_Solicitação", sortable: true },
        { key: "justificativa", label: "Solicitação", sortable: true },
        { key: "re_finalizado", label: "Encerrado_Por", sortable: true },
        { key: "parecer", label: "Resposta", sortable: true },
        /*
      {
          key: "exige_liberacao",
          label: "Exige aprovação",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "aprovado",
          label: "Aprovado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        */
        { key: "actions", label: "Atualizar" },
      ],

      tratativas: [
        { key: "id_solicitacao", label: "Id", sortable: true },
        {
          key: "dt_resposta",
          label: "Data_Resposta",
          sortable: true,
          formatter: (value, key, sacsolicitacoesEncerramentotratativa) => {
            return moment(sacsolicitacoesEncerramentotratativa.dt_resposta)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        { key: "respondido", label: "Resposta", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "justificativa", label: "Justificativa", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    atualizarParecer(idSelecionado) {
      const respostaSelecionada = this.sacResposta.find(
        (item) => item.id === idSelecionado
      );
      if (respostaSelecionada) {
        this.sacsolicitacaoEncerramento.parecer = respostaSelecionada.resposta;
      }
    },

    loadDepartamentos() {
      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/departamento`;
      axios
        .get(url, { params })
        .then((res) => {
          this.departamentos = res.data.map((inte) => {
            return { ...inte, value: inte.id_area, area: inte.area };
          });
        })
        .catch(showError);
    },

    loadAssunto() {
      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        depto_id: `${this.sacsolicitacaoEncerramento.departamento_id}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/assunto`;
      axios
        .get(url, { params })
        .then((res) => {
          this.assuntos = res.data.map((inte) => {
            return { ...inte, value: inte.id_modulo, modulo: inte.modulo };
          });
        })
        .catch(showError);
    },

    loadMotivo() {
      let params = {
        origem: "app",
        empresa_id: `${this.user.id_grupo_empresa}`,
        modulo_id: `${this.sacsolicitacaoEncerramento.assunto_id}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/informatica/sac/motivo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motivos = res.data.map((inte) => {
            return { ...inte, value: inte.id, motivo: inte.motivo };
          });
        })
        .catch(showError);
    },

    handleCheckboxChange(value) {
      if (value === "true") {
        this.postSac();
      }
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/sac/status`;
      axios
        .get(url, { params })
        .then((res) => {
          // Log para verificar os dados brutos recebidos
          console.log("Dados brutos do status recebidos:", res.data);

          this.statussEncerramento = res.data.map((sta) => {
            return {
              id_status: sta.id_status,
              status: sta.status,
              value: sta.id_status,
            };
          });

          // Log para verificar os dados após o mapeamento
          console.log(
            "Dados de status mapeados para Multiselect:",
            this.statussEncerramento
          );
        })
        .catch((error) => {
          console.error("Erro ao carregar status:", error);
          showError("Erro ao carregar status. Verifique o console."); // Use showError do global.js
        });
    },

    loadResposta() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/sac/resposta`;
      axios.get(url, { params }).then((res) => {
        this.sacResposta = res.data.map((resp) => {
          return { ...resp, value: resp.id, resposta: resp.resposta };
        });
      });
    },

    async loadPermissao() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/permissao`;

      try {
        const res = await axios.get(url, { params });
        this.permissoes = res.data.map((permissao) => {
          return { ...permissao, id_area: permissao.id_area };
        });
        this.loadsacsolicitacoesEncerramento();
      } catch (error) {
        console.error("Erro ao carregar permissões:", error);
        this.permissoes = [];
        showError(error);
      }
    },

    async loadsacsolicitacoesEncerramento() {
      let areaIds = "";
      if (this.permissoes && this.permissoes.length > 0) {
        areaIds = this.permissoes.map((p) => p.id_area).join(",");
      }

      const params = {
        empresa_id: this.user.id_empresa,
        funcionario_id: this.user.id_funcionario,
        status_id:
          this.value_status.length > 0
            ? `${this.value_status.map((r) => r.id_status).join(",")}`
            : "1",
        tipo: "atendente",
        origem: "web",
        gestor: this.user.gestor || false,
        id_area: areaIds,
        psg: this.user.psg,
      };

      const url = await `${baseApiUrl}/sac/solicitacoes_v2`;

      axios
        .get(url, { params })
        .then((res) => {
          this.sacsolicitacoesEncerramento = res.data;
        })
        .catch((err) => {
          console.error("Erro ao carregar solicitações SAC:", err);
          this.$bvToast.toast("Erro ao carregar solicitações.", {
            title: "Erro",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {});
    },

    loadsacsolicitacoesEncerramentoTratativas() {
      // Garante que haja um id_solicitacao para buscar as tratativas
      if (!this.sacsolicitacaoEncerramento.id_solicitacao) return;

      let params = {
        id_solicitacao: `${this.sacsolicitacaoEncerramento.id_solicitacao}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/id`;
      axios
        .get(url, { params })
        .then((res) => {
          this.sacsolicitacoesEncerramentotratativa = res.data;
        })
        .catch(showError);
    },

    loadSolicitacaoFoto() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        solicitacao_id:
          this.sacsolicitacaoEncerramento.id_solicitacao != null
            ? `${this.sacsolicitacaoEncerramento.id_solicitacao}`
            : null,
        origem: "consulta",
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes_v2/arquivos`;

      axios
        .get(url, { params })
        .then((res) => {
          this.solicitacao = res.data;
        })
        .catch((error) => {
          console.error("Erro ao carregar solicitação de foto:", error);
        });
    },

    loadCarregaSac(sacsolicitacoesEncerramento) {
      this.sacsolicitacaoEncerramento = { ...sacsolicitacoesEncerramento };
    },

    loadCarregaSacT(sacsolicitacoesEncerramentotratativa) {
      this.sacsolicitacoesEncerramentotratativa = {
        ...sacsolicitacoesEncerramentotratativa,
      };
    },

    async postSac() {
      const isUpdate =
        this.sacsolicitacaoEncerramento.id_solicitacao != null &&
        this.sacsolicitacaoEncerramento.id_solicitacao !== "";

      let corpo = {
        id_empresa_grupo: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_grupo_empresa}`,
        id_area: `${this.sacsolicitacaoEncerramento.departamento_id}`,
        id_modulo: `${this.sacsolicitacaoEncerramento.assunto_id}`,
        id_motivo: `${this.sacsolicitacaoEncerramento.motivo_id}`,
        justificativa: isUpdate
          ? `${this.sacsolicitacaoEncerramento.parecer}`
          : `${this.sacsolicitacaoEncerramento.justificativa}`,
        id_solicitacao: isUpdate
          ? `${this.sacsolicitacaoEncerramento.id_solicitacao}`
          : null,
        aprovado: this.sacsolicitacaoEncerramento.aprovado === true,
        funcionario_aprovacao_id: `${this.user.id_funcionario}`,
        dt_aprovacao: this.sacsolicitacaoEncerramento.dt_aprovacao || null,
        id_status: `${this.sacsolicitacaoEncerramento.id_status}`,
        psg: this.user.psg,
        funcionario_id: isUpdate ? undefined : `${this.user.id_funcionario}`,
      };

      const url = `${baseApiUrl}/informatica/sac/lancamentos`;

      try {
        const res = await axios.post(url, corpo);

        if (res.data && res.data.dados && res.data.dados.length > 0) {
          const solicitacaoRetornada = res.data.dados[0];
          const numeroSolicitacao = solicitacaoRetornada.id_solicitacao;

          if (!solicitacaoRetornada.id_funcionario_solicitante) {
            solicitacaoRetornada.id_funcionario_solicitante =
              this.user.id_funcionario;
          }
          if (!solicitacaoRetornada.nome) {
            solicitacaoRetornada.nome = this.user.nome;
          }
          if (!solicitacaoRetornada.area && this.departamentos.length > 0) {
            const depto = this.departamentos.find(
              (d) => d.value == solicitacaoRetornada.id_area
            );
            if (depto) solicitacaoRetornada.area = depto.area;
          }
          if (!solicitacaoRetornada.modulo && this.assuntos.length > 0) {
            const modulo = this.assuntos.find(
              (m) => m.value == solicitacaoRetornada.id_modulo
            );
            if (modulo) solicitacaoRetornada.modulo = modulo.modulo;
          }

          await this.postSacTratativa(solicitacaoRetornada, !isUpdate); // Passa true se for nova solicitação

          this.$toasted.global.defaultSuccess({
            message: `Solicitação #${numeroSolicitacao} ${
              isUpdate ? "atualizada" : "criada"
            } com sucesso!`,
          });

          this.loadsacsolicitacoesEncerramento();

          this.$nextTick(() => {
            this.$bvModal.hide("modal-multi-tratativas");
            this.reset();
          });
        } else {
          console.error("Resposta do backend inesperada:", res.data);
          showError(
            new Error("Resposta do backend inesperada ao salvar solicitação.")
          );
        }
      } catch (error) {
        showError(error);
      }
    },

    async postSacTratativa(solicitacaoPrincipalData, isNewRequest) {
      const idSolicitacaoParaTratativa =
        solicitacaoPrincipalData.id_solicitacao || this.idRetornoSolicitacao;

      let corpoTratativa = {
        id_solicitacao: `${idSolicitacaoParaTratativa}`,
        justificativa: `${this.sacsolicitacaoEncerramento.parecer}`,
        id_funcionario_resposta: `${this.user.id_funcionario}`,
        respondido_por: 2, // Atendente
        origem: "atendente",
        psg: this.user.psg,
      };

      const urlTratativa = `${baseApiUrl}/informatica/sac/lancamentostratativas`;

      try {
        await axios.post(urlTratativa, corpoTratativa);

        // 🟢 CORREÇÃO AQUI: Usando this.$socket.emit()
        if (this.$socket) {
          const eventData = {
            solicitacaoId: idSolicitacaoParaTratativa,
            userId: this.user.id_funcionario,
            isNew: isNewRequest, // Indica se é uma nova solicitação ou atualização/tratativa
            // Dados adicionais para a notificação
            solicitacaoInfo: solicitacaoPrincipalData,
            psg: this.user.psg,
          };

          // Decide qual evento emitir com base se é uma nova solicitação ou uma tratativa/atualização
          if (isNewRequest) {
            this.$socket.emit("novaSolicitacao", eventData);
            console.log("Evento 'novaSolicitacao' emitido:", eventData);
          } else {
            this.$socket.emit("atualizacaoSolicitacao", eventData);
            console.log("Evento 'atualizacaoSolicitacao' emitido:", eventData);
          }
        }
      } catch (error) {
        console.error("Erro ao gravar tratativa:", error);
        showError(error);
      }
    },

    postNotificacao() {
      const agora = moment().format("DD/MM/YYYY HH:mm");
      const corpo = {
        psg: this.user.psg,
        app: true,
        origem: "ML18",
        envio: "INDIVIDUAL",
        funcionario_id: `${this.sacsolicitacaoEncerramento.id_funcionario_solicitante}`,
        empresa_id: this.user.id_empresa,
        titulo_id: 1,
        origem_id: 1,
        status_id: 1,
        funcionario_cad_id: this.user.id_funcionario,
        descricao: `Nova tratativa para solicitação nº ${this.sacsolicitacaoEncerramento.id_solicitacao} às ${agora}`,
        data_envio: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`;
      axios
        .post(url, corpo)
        .then((res) => {})
        .catch(showError);
    },

    reset() {
      this.idRetornoSolicitacao = null;
      this.sacsolicitacaoEncerramento = {};
      this.sacsolicitacaoEncerramento.parecer = "";
      this.sacsolicitacoesEncerramentotratativa = [];
      this.sacResposta = [];
      this.departamentos = [];
      this.assuntos = [];
      this.motivos = [];
      this.loadDepartamentos();
      this.loadStatus();
      this.loadResposta();
    },

    limparFiltro() {
      this.search = "";
    },
  },

  created() {
    this.loadStatus();
    this.loadPermissao();
  },

  mounted() {
    if (this.$socket) {
      console.log("Socket.IO está disponível no mounted.");

      this.$socket.on("connect", () => {
        console.log("Conectado ao Socket.IO do frontend!");
        if (this.user && this.user.id_funcionario) {
          this.$socket.emit("authenticateUser", this.user.id_funcionario);
          const userAreaIds = this.permissoes.map((p) => p.id_area);
          if (userAreaIds.length > 0) {
            this.$socket.emit("joinRooms", userAreaIds.map(String));
          }
        }
      });

      this.$socket.on("disconnect", () => {
        console.warn("Desconectado do Socket.IO do frontend!");
      });

      this.$socket.on("solicitacaoAtualizadaUsuario", (data) => {
        this.$bvToast.toast(data.message, {
          title: "SAC Atualizado",
          variant: "info",
          solid: true,
          autoHideDelay: 5000,
        });
        this.loadsacsolicitacoesEncerramento();
      });

      this.$socket.on("novaSolicitacaoDepartamento", (data) => {
        this.$bvToast.toast(data.message, {
          title: "Nova Solicitação SAC",
          variant: "success",
          solid: true,
          autoHideDelay: 5000,
        });
        this.loadsacsolicitacoesEncerramento();
      });

      this.$socket.on("solicitacaoAtualizadaDepartamento", (data) => {
        this.$bvToast.toast(data.message, {
          title: "Atualização SAC (Departamento)",
          variant: "warning",
          solid: true,
          autoHideDelay: 5000,
        });
        this.loadsacsolicitacoesEncerramento();
      });
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#re-nome {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#funcao {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#re-solicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
  font-style: inherit;
}

#parecer {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#rfilancamentos {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#tabela-solicitacoes {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#__BVID__18 {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>
